import moment from 'moment'

// 暂时支持这三种
export const TRAINING_UPLOAD_TYPES = {
  IMAGE: 'img',
  VIDEO: 'video',
  PDF: 'pdf',
}

// 这是每种上传类型支持的各种参数
export const trainingUploadTypeOptions = {
  [TRAINING_UPLOAD_TYPES.IMAGE]: {
    label: '图片',
    accept: ['image/jpeg', 'image/png', 'image/jpg'],
    extensions: ['jpg', 'jpeg', 'png'],
    maxSizeMB: 20,
  },
  [TRAINING_UPLOAD_TYPES.VIDEO]: {
    label: '视频',
    accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
    extensions: ['mp4', 'avi', 'mov'],
    maxSizeMB: 1024,
  },
  [TRAINING_UPLOAD_TYPES.PDF]: {
    label: 'PDF',
    accept: ['application/pdf'],
    extensions: ['pdf'],
    maxSizeMB: 100,
  },
}

// acceptTypes 组件外部传进的支持类型，可多种类型
export function getTrainingUploadConfig (acceptTypes = [], multiple = true) {
  const types = acceptTypes.length ? acceptTypes : [TRAINING_UPLOAD_TYPES.IMAGE]

  // 获取每种类型的参数
  const options = types.map(type => trainingUploadTypeOptions[type]).filter(Boolean)

  // 合并accept，方便upload组件使用
  const accept = options.reduce((result, item) => result.concat(item.accept), [])

  // 合并支持的后缀
  const extensions = options.reduce((result, item) => result.concat(item.extensions), [])

  // 多种文件取最大的上传大小
  const maxSizeMB = Math.max.apply(null, options.map(item => item.maxSizeMB))
  const maxSizeLabel = maxSizeMB >= 1024
    ? `${(maxSizeMB / 1024).toFixed(maxSizeMB % 1024 === 0 ? 0 : 1)}GB`
    : `${maxSizeMB}MB`

  const labels = options.map(item => item.label).join('、')

  return {
    accept,
    extensions,
    maxFiles: multiple ? 0 : 1,
    maxSizeMB,
    tip: `${multiple ? '支持上传多个' : '只能上传一个'}${labels}文件，最大 ${maxSizeLabel}`,
  }
}

export function getFileExtension (name) {
  const parts = String(name || '').split('.')
  return parts.length > 1 ? parts.pop().toLowerCase() : ''
}

export function getTrainingUploadFileType (file) {
  const type = String((file && file.type) || '')
  const ext = getFileExtension(file && file.name)

  if (type.indexOf('image/') === 0 || ['jpg', 'jpeg', 'png'].includes(ext)) {
    return TRAINING_UPLOAD_TYPES.IMAGE
  }
  if (type.indexOf('video/') === 0 || ['mp4', 'avi', 'mov'].includes(ext)) {
    return TRAINING_UPLOAD_TYPES.VIDEO
  }
  if (type === 'application/pdf' || ext === 'pdf') {
    return TRAINING_UPLOAD_TYPES.PDF
  }
  return ''
}

// 检测选择文件是否合法
export function validateTrainingUploadFile (file, currentFiles, acceptTypes, multiple) {
  // 获取配置
  const config = getTrainingUploadConfig(acceptTypes, multiple)

  // 后缀
  const ext = getFileExtension(file && file.name)

  const typeMatched = file && (
    config.accept.includes(file.type) ||
    config.extensions.includes(ext)
  )

  if (!typeMatched || Number(file.size) > config.maxSizeMB * 1024 * 1024) {
    return {valid: false, message: config.tip, replaceAll: false}
  }

  // replaceAll参数代表单文件就替换，多文件就push
  return {
    valid: true,
    message: '',
    replaceAll: !multiple && Array.isArray(currentFiles) && currentFiles.length > 0,
  }
}

// 统一使用这组字段作为传入后端的参数
export function formatTrainingUploadFile (file, url, loginUser) {
  return {
    name: file.name,
    url,
    uid: file.uid,
    size: file.size,
    type: getTrainingUploadFileType(file),
    submit_admin_id: loginUser.id,
    submit_admin_name: loginUser.name,
    submit_at: moment().format('YYYY-MM-DD HH:mm:ss'),
  }
}



// WEBPACK FOOTER //
// ./src/views/training/components/training-upload.js